import { DataTypes } from "../../../data/DataManager";
import { FieldSchema } from "../../../Schema";

/**
 * Where the record sits within its cluster.
 *
 * Set from the cluster components preview when positions are tracked; see
 * {@link trackPositionInCluster}. Never edited as its own input.
 */
export const positionInCluster: FieldSchema = {
  name: "positionInCluster",
  data: { type: DataTypes.NUMBER },
  display: { displayed: false },
  grid: { displayed: false },
  form: { label: "Position in cluster", disabled: true, displayed: false },
};
